module.exports = require("@material-ui/core/DialogContentText");